export function buildAppRouteUrl(route: string): string {
  const normalizedRoute = route.startsWith('/') ? route : `/${route}`;
  return `${(process.env.VITE_URL || globalThis.window?.location.origin || '').replace(/\/$/, '')}${normalizedRoute}`;
}
